<template>
  <div>
    <upload @uploaded="getNtms"></upload>
    <ntm-list class="pt-3" :ntms="ntms" @removeNtm="removeNtm"></ntm-list>
  </div>
</template>
<script>
import myAxios from "@/services/myAxios";

import NtmList from "./NtmList";
import Upload from "./Upload";

export default {
  components: { Upload, NtmList },
  data() {
    return { ntms: null };
  },
  computed: {
    gcid() {
      return this.$store.getters['geoContent/gcid'];
    },
  },  
  mounted(){
    if (this.gcid) this.getNtms();
  },
  methods: {
    getNtms() {
      if (!this.gcid) return;
      myAxios
        .get("/api/ntm/GetNtms4GC?gcid=" + this.gcid)
        .then((resp) => {
          this.ntms = resp.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    removeNtm(id) {
      myAxios
        .delete("/api/ntm/" + id)
        .then((r) => {
          this.getNtms();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  },
  watch: {
    gcid: function () {
      if (this.gcid) this.getNtms();
    },
  },
};
</script>